import { render, staticRenderFns } from "./RnokAuth.vue?vue&type=template&id=6c770d5e&scoped=true"
import script from "./RnokAuth.vue?vue&type=script&lang=js"
export * from "./RnokAuth.vue?vue&type=script&lang=js"
import style0 from "./RnokAuth.vue?vue&type=style&index=0&id=6c770d5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c770d5e",
  null
  
)

export default component.exports